export function getCookie(cname, defaultValue) {
  let value = undefined;

  try {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        value = c.substring(name.length, c.length);
      }
    }

    value = JSON.parse(value);
  } catch (e) {
    // console.log(e)
  }

  return typeof value === 'undefined' ? defaultValue : value;
}

/* Cookie name, value (can be object), seconds */
export function setCookie(cname, cvalue, expirationInSeconds, domain) {
  try {
    if (typeof cvalue === 'object') {
      cvalue = JSON.stringify(cvalue);
    }

    cvalue = encodeURIComponent(cvalue);

    var d = new Date();
    d.setTime(d.getTime() + expirationInSeconds * 1000);
    var expires = 'expires=' + d.toUTCString();
    document.cookie =
      cname +
      '=' +
      cvalue +
      ';' +
      (domain ? 'domain=.' + domain + ';' : '') +
      expires +
      ';path=/';
  } catch (e) {
    return false;
  }
  return true;
}

export function deleteCookie(cname, domain) {
  document.cookie = `${cname}=;${
    domain ? 'domain=' + domain + ';' : ''
  } expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

/* Doesn't delete http only cookies, since they can't be deleted from the browser */

// export function deleteAllCookies() {
//   var cookies = document.cookie.split(";");

//   for (var i = 0; i < cookies.length; i++) {
//       var cookie = cookies[i];
//       var eqPos = cookie.indexOf("=");
//       var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
//       document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
//   }
// }
